// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"8a51c903","453":"7cef3852","783":"a54a2ae3","907":"dcee678e"}[chunkId] + ".chunk.js";
};